import Joi from '@hapi/joi';

export function required(value, message = 'Required') {
  if (value === null || value === undefined) return message;

  if (!value.toString().trim()) {
    return message;
  }
}
export function  validateEmail (email){
 
  console.log("email in triat", email);
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const showErrMsg = document.querySelector("[data-tx-errorEmail]");
  return re.test(String(email).toLowerCase())
    
};
export function email(
  value,
  {
    tlds: { allow = false } = {},
    allowUnicode = true,
    message = 'Invalid email address',
  } = {},
) {
  const emailSchema = Joi.string()
    .email({ tlds: { allow }, allowUnicode })
    .messages({
      'string.email': message,
    });

  const { error } = emailSchema.validate(value);

  return error && error.message;
}

export function phoneNumber(
  value,
  {
    minDigits = 10,
    maxDigits = minDigits,
    message = 'Invalid phone number',
  } = {},
) {
  const phoneNumberRegex = RegExp(`^\\d{${minDigits},${maxDigits}}$`);

  if (!phoneNumberRegex.test(value)) {
    return message;
  }
}

export default {
  required,
  email,
  phoneNumber,
};
